var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoutSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.905 0H43.1666C15.9311 0 0.5 15.4311 0.5 42.6666V117.334C0.5 144.569 15.9311 160 43.1666 160H117.905C145.14 160 160.5 144.569 160.5 117.334V42.6666C160.5 15.4311 145.14 0 117.905 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3333 109.167C94.7428 109.167 109.667 94.2428 109.667 75.8333C109.667 57.4238 94.7428 42.5 76.3333 42.5C57.9238 42.5 43 57.4238 43 75.8333C43 94.2428 57.9238 109.167 76.3333 109.167Z",
    stroke: "#BDBDBB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.998 117.496L99.8726 99.3711",
    stroke: "#BDBDBB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoutSearch);
export default __webpack_public_path__ + "static/media/scout-search.0f4b3ff2e6d65388b2c39d2563b0e89a.svg";
export { ForwardRef as ReactComponent };